// api should be here
import { http } from '@/utils/http';
import qs from 'qs';
// 活动api baseurl
const urlPrefix = 'vote/2022project/q1/2022qglh/controller.php?enews=';

const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};

const getList = (page: any ) => {
  return http.get(`${urlPrefix}vote-list&page=${page}`);
};

const getDetail = (id: any) => {
  return http.get(`${urlPrefix}detail&id=${id}`);
};

const save = (data: any) => {
  return http.post(`${urlPrefix}save`, qs.stringify(data));
};

export { getBaseInfo, getList, getDetail, save };
